import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { useSameFontSizeOnMobileExperiment } from '../../hooks/experiments';

const SameFontSizeOnMobileStyle = createGlobalStyle`
  body {
    ${media.smallOnly`
      font-size: ${layout.fontSizes.base.desktop.rem};
    `}
  }
`;

const MobileFontSizeExperiment = () => {
  const { sameFontSizeOnMobile } = useSameFontSizeOnMobileExperiment();
  return sameFontSizeOnMobile ? <SameFontSizeOnMobileStyle /> : null;
};

export default MobileFontSizeExperiment;
